import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCallOnboardingAPI } from "../serviceCall"
import { setLoading } from "../../feature/authSlice"

export const ifscApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallOnboardingAPI({
      url: `${apiConstants.Invoices.GET_BANK_DETAILS}?ifsc=${data}`,
      method: 'get',
      //   data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error.response.data.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
